import { getListFileReviewProject } from "@/api/endpoint/reviews/get-list-file-review-project";
import { MediaTypeEnum } from "@/constants/enum/media";
import { PAGE_SIZE_FILE } from "@/constants/number";
import { ProjectContext } from "@/context/project.context";
import ListReview from "@/modules/common/ProjectDetail/ListReview";
import clsx from "clsx";
import { useContext, useMemo, useRef, useState } from "react";
import ReviewFilter from "./ReviewFilter";
import AboutProject from "./RightContent/AboutProject";
import Evaluation from "./RightContent/Evaluation";
import FileMedia from "./RightContent/FileMedia";

let TABS = [
  {
    key: "review",
    label: "Review",
    component: <ListReview reviewFilter={<ReviewFilter />} />,
  },
  {
    key: "vote",
    label: "Tiêu chí đánh giá",
    component: <Evaluation />,
  },
  {
    key: "file",
    label: "File",
    component: <FileMedia />,
  },
  {
    key: "Thông tin",
    label: "Thông tin",
    component: <AboutProject />,
  },
];

const ProjectMobileTab = () => {
  const [activeTab, setActiveTab] = useState("review");
  const { projectListFile, setProjectListFile, setSelectedViewFiles, project } =
    useContext(ProjectContext);
  const scrollTab = useRef<HTMLDivElement>(null);

  const tabMobile = useMemo(() => {
    const isHasScore = project?.votes?.find((vote) => vote.score > 0);
    if (!isHasScore) {
      return TABS.filter((item) => {
        return item.key !== "vote";
      });
    } else return TABS;
  }, [project?.votes]);

  const handleChangeTabFile = async () => {
    const res = await getListFileReviewProject(project?._id, {
      type: `${MediaTypeEnum.IMAGE},${MediaTypeEnum.VIDEO},${MediaTypeEnum.FILE}`,
      page: 1,
      limit: PAGE_SIZE_FILE,
    });
    if (res) {
      setProjectListFile({
        ...res,
        results: [...res.results],
      });
    }
  };
  return (
    <div className="bg-white flex-[1_1_auto] w-full ">
      <div
        className="overflow-auto flex w-full flex-nowrap  no-scrollbar"
        ref={scrollTab}>
        {tabMobile.map((tab) => {
          const isActive = tab.key === activeTab;
          return (
            <div
              key={tab.key}
              onClick={(e) => {
                scrollTab.current.scrollTo({
                  left: (e.target as HTMLDivElement).offsetLeft,
                  behavior: "smooth",
                });
                if (activeTab === "file") {
                  handleChangeTabFile();
                }
                setActiveTab(tab.key);
                if (tab.key === "file") {
                  setSelectedViewFiles({
                    currentFile: null,
                    files: projectListFile?.results,
                  });
                }
              }}
              className={clsx(
                "cursor-pointer border-b border-grey-200 hover:border-b-blue-500 hover:text-blue-500  px-6 py-3 whitespace-nowrap text-grey-500 flex-1 text-center",
                isActive ? "!text-blue-500 border-b-blue-500" : ""
              )}>
              {tab.label}
            </div>
          );
        })}
      </div>
      <div className="tab-content h-full" key={activeTab}>
        {tabMobile.find((item) => item.key === activeTab)?.component}
      </div>
    </div>
  );
};

export default ProjectMobileTab;
